(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
function buddyCheckTradeMinimum() {
document.querySelectorAll('[data-buddy-bag][data-trade="true"]').forEach((bag) => {
 const currency = bag.dataset.currency;
 const rate = currency === 'GBP' ? 1 : Number(window.Shopify?.currency?.rate);
 const active = window.Shopify?.currency?.active;
 const button = bag.querySelector('[data-buddy-checkout]');
 const message = bag.querySelector('.buddy-bag-minimum');
 if (!Number.isFinite(rate) || rate <= 0 || (currency !== 'GBP' && active !== currency)) {
  if (button) button.disabled = true;
  bag.dataset.minimumBlocked = 'true';
  message.textContent = bag.dataset.currencyError;
  return;
 }
 const threshold = (currency === 'CAD' || currency === 'USD') ? 15000 : Math.ceil(7500 * rate);
 const remaining = Math.max(0, threshold - Number(bag.dataset.total));
 bag.dataset.minimumBlocked = remaining > 0 ? 'true' : 'false';
 if (button) button.disabled = remaining > 0 || bag.dataset.dirty === 'true';
 if (remaining > 0) {
  const amount = new Intl.NumberFormat(bag.dataset.locale || 'en', {style:'currency',currency,currencyDisplay:'code'}).format(remaining / 100);
  message.textContent = bag.dataset.minimumMessage.replace('BUDDY_AMOUNT', amount);
 } else message.textContent = bag.dataset.readyMessage;
});
}
buddyCheckTradeMinimum();
document.addEventListener('shopify:section:load', buddyCheckTradeMinimum);

document.addEventListener('input', (event) => {
  if (!event.target.matches('.buddy-bag-quantity')) return;
  const bag = event.target.closest('[data-buddy-bag]');
  bag.dataset.dirty = 'true';
  const checkout = bag.querySelector('[data-buddy-checkout]');
  if (checkout) checkout.disabled = true;
  bag.querySelector('.buddy-bag-dirty').textContent = bag.dataset.dirtyMessage;
});
document.addEventListener('submit', (event) => {
  const bag = event.target.querySelector('[data-buddy-bag]');
  if ((bag?.dataset.dirty === 'true' || bag?.dataset.minimumBlocked === 'true') && event.submitter?.name === 'checkout') {
    event.preventDefault();
    if (bag.dataset.dirty === 'true') bag.querySelector('.buddy-bag-dirty').textContent = bag.dataset.dirtyMessage;
  }
});
document.addEventListener('click', async (event) => {
 const button = event.target.closest('[data-buddy-voucher-apply]');
 if (!button || button.disabled) return;
 const box = button.closest('[data-buddy-voucher]');
 const bag = box.closest('[data-buddy-bag]');
 const status = box.querySelector('[data-buddy-voucher-status]');
 if (bag.dataset.dirty === 'true') {status.textContent = bag.dataset.dirtyMessage; return;}
 const code = box.querySelector('input').value.trim();
 if (!code) {status.textContent = box.dataset.empty; return;}
 const label = button.textContent;
 button.disabled = true; button.textContent = box.dataset.applying;
 status.textContent = '';
 try {
  const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
   method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:code,updates:Object.fromEntries(Array.from(document.querySelectorAll('[data-buddy-bonus-key]')).map(line=>[line.dataset.buddyBonusKey,0]))})
  });
  const cart = await response.json();
  if (!response.ok) throw new Error(box.dataset.error);
  if (Array.isArray(cart.discount_codes) && !cart.discount_codes.some(discount => discount.code.toLowerCase() === code.toLowerCase() && discount.applicable)) throw new Error(box.dataset.error);
  window.location.reload();
 } catch (error) {status.textContent = box.dataset.error; button.disabled = false; button.textContent = label;}
});
document.addEventListener('keydown', (event) => {
 if (event.key !== 'Enter' || !event.target.matches('[data-buddy-voucher] input')) return;
 event.preventDefault();
 event.target.closest('[data-buddy-voucher]').querySelector('[data-buddy-voucher-apply]').click();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.querySelectorAll('form.buddy-filters').forEach((form) => {
  const params = new URLSearchParams(window.location.search);
  const previewId = params.get('preview_theme_id');
  const clear = form.querySelector('[data-buddy-clear]');
  if (previewId && clear) {
    const url = new URL(clear.href, window.location.origin);
    url.searchParams.set('preview_theme_id', previewId);
    clear.href = url.toString();
  }
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    const tags = Array.from(form.querySelectorAll('[data-buddy-filter]'))
      .filter((control) => control.type !== 'checkbox' || control.checked)
      .map((control) => control.value).filter(Boolean);
    const base = form.dataset.collectionUrl.replace(/\/$/, '');
    const url = new URL(base + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : ''), window.location.origin);
    if (previewId) url.searchParams.set('preview_theme_id', previewId);
    const sort = params.get('sort_by');
    if (sort) url.searchParams.set('sort_by', sort);
    window.location.assign(url.toString());
  });
});
document.addEventListener('submit', async (event) => {
const form = event.target.closest('[data-buddy-quick]');
if (!form) return;
event.preventDefault();
if (form.dataset.busy) return;
const button = form.querySelector('button'), status = form.querySelector('[role="status"]'), label = button.textContent;
form.dataset.busy = 'true'; button.disabled = true; button.textContent = form.dataset.adding; status.textContent = '';
const root = window.Shopify?.routes?.root || '/';
try {
 const response = await fetch(root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:form.elements.id.value,quantity:Number(form.elements.quantity.value),properties:form.elements['properties[_buddy_wholesale]'] ? {_buddy_wholesale:'true'} : {}}]})});
 const result = await response.json();
 if (!response.ok) throw new Error(result.description || form.dataset.error);
 status.textContent = form.dataset.added;
 document.dispatchEvent(new CustomEvent('buddy:cart-updated'));
 try {
  const response = await fetch(root + 'cart.js', {cache:'no-store'});
  if (response.ok) {const cart = await response.json(); document.querySelectorAll('.cart-link').forEach(link => {link.textContent = form.dataset.bag.replace('COUNT', cart.item_count);});}
 } catch {}
} catch (error) {status.textContent = error.message || form.dataset.error;}
finally {button.textContent = label; button.disabled = false; delete form.dataset.busy;}
});

  } catch(e) { console.error(e); }
})();
})();
